<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Colour';
                }
            },
            component_id: {
                default(){
                    return 'hardware_colour';
                }
            },
            slab: {
                required: true,
            },
            openingDirection: {
                required: true
            },
            doorRange: {
                required: true
            },
            profile: {
                required: true
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/colour/';
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.openingDirection, this.doorRange, this.profile);
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-colour?slab=' + this.slab + '&opening_direction=' + this.openingDirection + '&door_range=' + this.doorRange + '&profile=' + this.profile;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.openingDirection + '_' + this.doorRange + '_' + this.profile;
            },
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'openingDirection': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'profile': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
